export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'

export default (notificationId: string) => ({
  type: REMOVE_NOTIFICATION,
  notificationId,
})
